const state = {
    data: [],
    badges: {
        new: 0,
        in_progress: 0,
        ended: 0
    },
}

const mutations = {
    storeOrders (state, payload) {
        state.data = payload
    },

    storeNewOrders(state, payload) {
        state.data = payload
        state.badges.new = payload.length
    },

    storeInProgressOrders(state, payload) {
        state.data = payload
        state.badges.in_progress = payload.length
    },

    storeEndedOrders(state, payload) {
        state.data = payload
    },

    storeOrder (state, payload) {
        state.data.unshift(payload)

        state.badges.new += 1
        state.badges.ended += 1
    },

    changeOrderState (state, payload) {
        const curOrder = state.data.find(item => item.id === payload.id)
        curOrder.state = payload.state
    },

    changeBadgesState(state, payload) {
        state.badges = payload
    }
}

const actions = {}

const getters = {
    getOrdersNew: state => state.data.filter(item => item.state === 1 || item.state === 3 || item.state === 9),
    getOrdersInProgress: state => state.data.filter(item => item.state > 3 && item.state < 7),
    getOrdersEnded: state => state.data.filter(item => item.state < 0 || (item.state > 6 && item.state < 9)),

    getOrdersCount: state => state.badges.ended,
    getOrdersNewCount: state => state.badges.new,
    getOrdersInProgressCount: state => state.badges.in_progress
}

export default {
    state,
    mutations,
    actions,
    getters
}
